/**
 * PAPAPATTES — fiche produit : aucune option de livraison (supplément)
 * n'est présélectionnée à l'ouverture. Au clic sur « Ajouter au panier »,
 * un popup chaleureux met la livraison en avant puis disparaît seul.
 *
 * Réglages (Personnaliser le thème > Papapattes — Livraison) via window.PP_LIV :
 *   allowEmpty : true  = ajout autorisé sans option choisie (popup de rappel)
 *                false = ajout bloqué tant qu'aucune option n'est choisie
 *   seconds    : durée d'affichage du popup (0 = illimitée : reste jusqu'à la fermeture / au choix)
 */
(function () {
  var cfg = window.PP_LIV || {};
  var allowEmpty = !!cfg.allowEmpty;
  var seconds = Math.max(0, Number(cfg.seconds) || 0); // 0 = illimitée
  var chosen = false;
  var timer;
  var FS = '.product-form__input--livraison, .pap-liv__fieldset';

  function fieldsets() {
    return Array.prototype.filter.call(document.querySelectorAll(FS), function (f) { return f.offsetParent !== null; });
  }
  function hasChecked() {
    return Array.prototype.some.call(fieldsets(), function (fs) { return fs.querySelector('input:checked'); });
  }

  function clearSelection() {
    if (chosen) return;
    fieldsets().forEach(function (fs) {
      fs.querySelectorAll('input[type="radio"]:checked').forEach(function (r) { r.checked = false; });
    });
  }

  var hlTimer;
  function clearHighlight() {
    clearTimeout(hlTimer);
    fieldsets().forEach(function (f) { f.classList.remove('pp-liv--highlight'); });
  }
  // Ferme seulement le popup : la mise en évidence de la livraison reste jusqu'à la fin de la durée réglée.
  function closePopup() {
    clearTimeout(timer);
    var p = document.getElementById('pp-liv-popup');
    if (p) p.remove();
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest(FS) && e.isTrusted) {
      chosen = true;
      closePopup();
      clearHighlight();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    clearSelection();
    var info = document.querySelector('product-info');
    if (info && window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(clearSelection, 60); })
        .observe(info, { childList: true, subtree: true });
    }
  });

  function deliveryText() {
    var chk = document.querySelector('.product-form__input--livraison input:checked, .pap-liv__fieldset input:checked');
    if (chk) {
      var lab = chk.closest('label') || document.querySelector('label[for="' + chk.id + '"]');
      if (lab) return lab.textContent.replace(/\s+/g, ' ').trim();
    }
    var n = document.querySelector('.pap-liv__option span');
    return n ? n.textContent.replace(/\s+/g, ' ').trim() : 'Livraison estimée entre 4 et 7 jours';
  }

  function showPopup(blocked, text) {
    closePopup();
    clearHighlight();
    var list = fieldsets();
    list.forEach(function (fs) { fs.classList.add('pp-liv--highlight'); });
    if (seconds > 0) hlTimer = setTimeout(clearHighlight, seconds * 1000);
    if (blocked && list[0]) list[0].scrollIntoView({ behavior: 'smooth', block: 'center' });

    var pop = document.createElement('div');
    pop.id = 'pp-liv-popup';
    pop.setAttribute('role', 'status');
    pop.style.setProperty('--pp-liv-s', seconds + 's');
    var head = blocked ? 'Choix du mode de livraison' : 'Article ajouté au panier';
    var sub = blocked
      ? 'Veuillez sélectionner un mode de livraison avant d’ajouter cet article au panier. Vous pourrez le modifier ultérieurement depuis votre panier.'
      : 'Vous pourrez modifier votre mode de livraison depuis votre panier.';
    var box = blocked ? 'Veuillez choisir votre livraison' : (text || deliveryText());
    pop.innerHTML =
      '<button type="button" class="pp-liv-popup__x" aria-label="Fermer">×</button>' +
      '<div class="pp-liv-popup__head">' + head + '</div>' +
      '<div class="pp-liv-popup__sub"></div>' +
      '<div class="pp-liv-popup__deliv"><span class="pp-liv-popup__txt"></span></div>' +
      '<button type="button" class="pp-liv-popup__ok">Fermer</button>' +
      '<div class="pp-liv-popup__bar"></div>';
    pop.querySelector('.pp-liv-popup__sub').textContent = sub;
    pop.querySelector('.pp-liv-popup__txt').textContent = box;
    document.body.appendChild(pop);
    pop.querySelector('.pp-liv-popup__x').addEventListener('click', closePopup);
    pop.querySelector('.pp-liv-popup__ok').addEventListener('click', closePopup);
    if (seconds > 0) timer = setTimeout(closePopup, seconds * 1000);
    else pop.querySelector('.pp-liv-popup__bar').remove();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="add"]');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    if (!fieldsets().length) return;
    if (!hasChecked() && !allowEmpty) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showPopup(true);
      return;
    }
  }, true);

  // Filet de sécurité : soumission au clavier (Entrée) sans passer par le bouton.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    if (!fieldsets().length || hasChecked() || allowEmpty) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showPopup(true);
  }, true);
})();
